<div class="regras-container">
  <mat-card class="militar-info" *ngIf="beneficiario">
    <h2>Dados do Militar</h2>
    <div class="info-column">
      <span><strong>Matrícula:</strong> {{ beneficiario.matricula }}</span>
      <span><strong>Nome:</strong> {{ beneficiario.nome }}</span>
      <span><strong>ID Funcional:</strong> {{ beneficiario.idFuncional }}</span>
      <span><strong>CPF:</strong> {{ beneficiario.cpf }}</span>
      <span><strong>Órgão:</strong> {{ beneficiario.orgao?.sigla || beneficiario.orgao }}</span>
    </div>
  </mat-card>

  <app-etapas-beneficio [etapaSelecionada]="7"></app-etapas-beneficio>

  <mat-card class="regras-card">
    <mat-card-header>
      <mat-card-title class="header-title">Análise Prévia</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <!-- Loading Spinner -->
      <div *ngIf="loading" class="loading-container">
        <mat-spinner diameter="50"></mat-spinner>
        <p>Carregando análise de regras...</p>
      </div>

      <!-- Conteúdo Principal -->
      <div *ngIf="!loading && analiseData">
        <!-- Dados Utilizados na Análise -->
        <div class="dados-utilizados-section">
          <h3>Dados Utilizados na Análise</h3>

          <div class="dados-grid">
            <div class="dado-item">
              <label>Matrícula</label>
              <input type="text" [value]="analiseData.matricula" readonly>
            </div>

            <div class="dado-item">
              <label>Data Admissão</label>
              <input type="text" [value]="analiseData.dataAdmissao | date: 'dd/MM/yyyy'" readonly>
            </div>

            <div class="dado-item">
              <label>Idade</label>
              <input type="text" [value]="analiseData.idade" readonly>
            </div>

            <div class="dado-item">
              <label>Sexo</label>
              <input type="text" [value]="analiseData.sexo" readonly>
            </div>

            <div class="dado-item">
              <label>Data da Reserva/Reforma</label>
              <input type="date" [(ngModel)]="dataAposentadoria">
            </div>
          </div>

          <fieldset><legend>Dados específicos militares</legend>
            <label>Ingresso na carreira <input type="date" [(ngModel)]="dadosMilitares.dataIngressoCarreira"></label>
            <label>Categoria <select [(ngModel)]="dadosMilitares.categoriaPosto"><option [ngValue]="null">Não informada</option><option value="PRACA">Praça</option><option value="OFICIAL">Oficial</option></select></label>
            <label>Tempo militar (dias) <input type="number" min="0" [(ngModel)]="dadosMilitares.diasTempoMilitar"></label>
            <label>Referência dos tempos <input type="date" [(ngModel)]="dadosMilitares.dataReferenciaTempos"></label>
            <label>Fonte da apuração <input [(ngModel)]="dadosMilitares.fonteTempos"></label>
            <label>Opção por incapacidade <select [(ngModel)]="dadosMilitares.opcaoIncapacidade"><option [ngValue]="null">Não informada</option><option value="INTEGRAL">Integral</option><option value="PROPORCIONAL">Proporcional</option></select></label>
            <label>Número do laudo <input [(ngModel)]="dadosMilitares.numeroLaudo"></label>
            <label>Data do laudo <input type="date" [(ngModel)]="dadosMilitares.dataLaudo"></label>
            <label>Contribuição na data do laudo (dias) <input type="number" min="0" [(ngModel)]="dadosMilitares.diasContribuicaoNaDataLaudo"></label>
            <p>Para a análise considerar o laudo, informe número e data e mantenha o laudo pericial anexado (na tela de requerimento ou na aba 9). A validade pericial continua sujeita à conferência.</p>
            <button mat-stroked-button (click)="salvarDadosMilitares()">Salvar dados e recalcular</button>
          </fieldset>
          <div class="checkbox-section">
            <mat-checkbox
              [checked]="exibirApenasQueAtendem"
              (change)="toggleExibirApenas()">
              Exibir Apenas Regras que Atendem
            </mat-checkbox>
          </div>
        </div>

        <!-- Análise - Tabela de Regras -->
        <div class="analise-section">
          <h3>Análise</h3>

          <div class="table-container">
            <table mat-table [dataSource]="getRegrasExibidas()" class="regras-table">

              <!-- Coluna Descrição da Regra -->
              <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef>Descrição da Regra</th>
                <td mat-cell *matCellDef="let regra" class="descricao-cell">
                  {{ regra.descricao }}
                  <ul *ngIf="regra.pendencias?.length"><li *ngFor="let pendencia of regra.pendencias">{{ pendencia }}</li></ul>
                </td>
              </ng-container>

              <!-- Coluna Análise -->
              <ng-container matColumnDef="atende">
                <th mat-header-cell *matHeaderCellDef>Análise</th>
                <td mat-cell *matCellDef="let regra">
                  <span [class]="regra.atende ? 'status-badge status-atende' : 'status-badge status-nao-atende'">
                    {{ regra.pendencias?.length ? 'Dados pendentes' : regra.atende ? 'Atende' : 'Não Atende' }}
                  </span>
                </td>
              </ng-container>

              <!-- Coluna Selecionada -->
              <ng-container matColumnDef="selecionada">
                <th mat-header-cell *matHeaderCellDef>Selecionada</th>
                <td mat-cell *matCellDef="let regra" class="selecionada-cell">
                  <span class="status-text">
                    {{ regra.regraSelecionada ? 'Selecionada' : 'Não Selecionada' }}
                  </span>
                </td>
              </ng-container>

              <!-- Coluna Ações -->
              <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef>Ações</th>
                <td mat-cell *matCellDef="let regra" class="acoes-cell">
                  <div class="acoes-buttons">
                    <div class="acoes-row">
                      <button
                        *ngIf="regra.atende"
                        mat-mini-fab
                        color="primary"
                        (click)="toggleSelecao(regra)"
                        matTooltip="Selecionar/Desselecionar"
                        class="action-btn">
                        <mat-icon>{{ regra.regraSelecionada ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                      </button>

                      <button
                        mat-mini-fab
                        color="accent"
                        (click)="downloadQTC(regra)"
                        matTooltip="Download QTC"
                        class="action-btn">
                        <mat-icon>picture_as_pdf</mat-icon>
                      </button>

                      <button
                        mat-mini-fab
                        color="warn"
                        (click)="downloadQRB(regra)"
                        matTooltip="Download QRB"
                        class="action-btn">
                        <mat-icon>description</mat-icon>
                      </button>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>

          <!-- Mensagem quando não há regras -->
          <div *ngIf="getRegrasExibidas().length === 0" class="no-data-message">
            <mat-icon>info</mat-icon>
            <p>{{ exibirApenasQueAtendem ? 'Nenhuma regra atendida encontrada' : 'Nenhuma regra disponível' }}</p>
          </div>
        </div>

        <!-- Botões de Ação -->
        <div class="actions-footer">
          <button mat-raised-button color="primary" (click)="voltarParaHome()">
            <mat-icon>arrow_back</mat-icon>
            Voltar para Pesquisa
          </button>

          <button mat-raised-button color="accent" (click)="carregarAnaliseRegras()">
            <mat-icon>refresh</mat-icon>
            Atualizar Análise
          </button>
        </div>
      </div>

      <!-- Mensagem de erro -->
      <div *ngIf="!loading && !analiseData" class="error-message">
        <mat-icon>error</mat-icon>
        <p>Não foi possível carregar a análise de regras</p>
        <button mat-raised-button color="primary" (click)="carregarAnaliseRegras()">
          Tentar Novamente
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
